import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReliableChoicePopup } from '../../components/ChoicePopup';
import { selectIsReliable, selectNewbuildingUrl } from '../../selectors/newbuilding';

export const ReliableChoicePopupContainer: React.VFC = () => {
  const isReliable = useSelector(selectIsReliable);
  const url = useSelector(selectNewbuildingUrl);

  if (!isReliable) {
    return null;
  }

  return <ReliableChoicePopup url={url + '#reliable'} />;
};
